const rootConst = 'MERCHANT_MENU_BUILDER';

export const GET_MENU_BUILDER_LIST = `${rootConst}/GET_MENU_BUILDER_LIST`;

export const CREATE_MENU_BUILDER = `${rootConst}/CREATE_MENU_BUILDER`;
export const UPDATE_SELECTED_MENU_BUILDER = `${rootConst}/UPDATE_SELECTED_MENU_BUILDER`;
export const REMOVE_SELECTED_MENU_BUILDER = `${rootConst}/REMOVE_SELECTED_MENU_BUILDER`;

export const INIT_FORM = {
  branch_uuid: '',
  name: '',
  description: '',
  type: 'qr-code',
};

export const OPTION_SORT_BY = [
  {
    label: 'ASCENDING',
    value: 'asc',
  },
  {
    label: 'DESCENDING',
    value: 'desc',
  },
];

export const OPTION_ORDER_BY = [
  {
    label: 'CREATED AT',
    value: 'created_at',
  },
  {
    label: 'NAME',
    value: 'name',
  },
];
